import Vue from 'vue'
import Router from 'vue-router'

import MIndex from '@/components/m_index'
import PcIndex from '@/components/pc_index'
import homePage from '@/components/homePage'
import aboutUs from '@/components/aboutUs'
import product from '@/components/product'
import productDetail from '@/components/productDetail'
import customerService from '@/components/customerService'
import advisersRecruited from '@/components/advisersRecruited'
import business from '@/components/business'
import apply from '@/components/apply'
import activity from '@/components/activity'
import picDetail from '@/components/picDetail'
import legalNotice from '@/components/legalNotice'
import privacy from '@/components/privacy'
import companyNewsDetail from '@/components/companyNewsDetail'
import cl from '@/components/cldescription'
import customerServiceDetail from '@/components/customerServiceDetail'
import backstage from '@/components/backstage'
import htHome from '@/components/htHome'
import scheme from '@/components/ht_scheme'
import info from '@/components/ht_info'
import serverInfo from '@/components/ht_serverInfo'
import customCase from '@/components/ht_customCase'
import ht_apply from '@/components/ht_apply'
import pic from '@/components/ht_pic'
import review from '@/components/ht_review'
import joinWe from '@/components/ht_joinWe'
import experience from '@/components/ht_experience'
import ht_activity from '@/components/ht_activity'
import addactivity from '@/components/ht_addactivity'
import updateActivity from '@/components/ht_updateActivity'
import enterpriseInfo from '@/components/ht_enterpriseInfo'

import MhomePage from '@/components/mobile/MhomePage'
import navList from '@/components/mobile/navList'
import Mproduct from '@/components/mobile/Mproduct'
import MaboutUs from '@/components/mobile/MaboutUs'
import McustomerService from '@/components/mobile/McustomerService'
import MaddAdvisers from '@/components/mobile/MaddAdvisers'
import Mbusiness from '@/components/mobile/Mbusiness'
import Mapply from '@/components/mobile/Mapply'
import Msign from '@/components/mobile/Msign'
import McompanyNewsDetail from '@/components/mobile/McompanyNewsDetail'
import MserverDetail from '@/components/mobile/MserverDetail'
import MlegalNotice from '@/components/mobile/MlegalNotice'
import Mprivacy from '@/components/mobile/Mprivacy'
import Mactivity from '@/components/mobile/Mactivity'
import MpicDetail from '@/components/mobile/MpicDetail'

Vue.use(Router)

const router = new Router({
//   mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash) {
        return {selector: to.hash}
      }else{
          return {x:0,y:0}
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'PcIndex',
      omponent: 'PcIndex'
    },
    {
      path: '/pc_index',
      name: 'PcIndex',
      component: PcIndex,
      redirect: '/homePage',
      children: [
        {
          path: '/homePage',
          name: 'homePage',
          component: homePage
        },
        {
          path: '/about/:tab',
          name: 'aboutUs',
          component: aboutUs
        },
        {
          path: '/product',
          name: 'product',
          component: product
        },
        {
          path: '/productDetail/:id',
          name: 'productDetail',
          component: productDetail
        },
        {
          path: '/companyNewsDetail/:id/:path',
          name: 'companyNewsDetail',
          component: companyNewsDetail
        },
        {
          path: '/customerService',
          name: 'customerService',
          component: customerService
        },
        {
          path: '/serviceDetail',
          name: 'serviceDetail',
          component: customerServiceDetail
        },
        {
          path: '/advisersRecruited',
          name: 'advisersRecruited',
          component: advisersRecruited
        },
        {
          path: '/business',
          name: 'business',
          component: business
        },
        {
          path: '/apply',
          name: 'apply',
          component: apply
        },
        {
          path: '/cl',
          name: 'cl',
          component: cl
        },
        {
          path: '/activity',
          name: 'activity',
          component: activity
        },
        {
          path: '/picDetail',
          name: 'picDetail',
          component: picDetail
        },
        {
          path: '/legalNotice',
          name: 'legalNotice',
          component: legalNotice
        },
        {
          path: '/privacy',
          name: 'privacy',
          component: privacy
        }
      ]
    },
    {
      path: '/m_index',
      name: 'MIndex',
      component: MIndex,
      redirect: '/m_homePage',
      children: [
        {
          path: '/m_homePage',
          name: 'MhomePage',
          component: MhomePage
        },
        {
          path: '/navList',
          name: 'navList',
          component: navList
        },
        {
          path: '/Mproduct',
          name: 'Mproduct',
          component: Mproduct
        },
        {
          path: '/McustomerService',
          name: 'McustomerService',
          component: McustomerService
        },
        {
          path: '/MaddAdvisers',
          name: 'MaddAdvisers',
          component: MaddAdvisers
        },
        {
          path: '/Mbusiness',
          name: 'Mbusiness',
          component: Mbusiness
        },
        {
          path: '/Mapply',
          name: 'Mapply',
          component: Mapply
        },
        {
          path: '/Msign',
          name: 'Msign',
          component: Msign
        },
        {
          path: '/McompanyNewsDetail/:id',
          name: 'McompanyNewsDetail',
          component: McompanyNewsDetail
        },
        {
          path: '/MserverDetail/:id',
          name: 'MserverDetail',
          component: MserverDetail
        },
        {
          path: '/MlegalNotice',
          name: 'MlegalNotice',
          component: MlegalNotice
        },
        {
          path: '/Mprivacy',
          name: 'Mprivacy',
          component: Mprivacy
        },
        {
          path: '/Mactivity',
          name: 'Mactivity',
          component: Mactivity
        },
        {
          path: '/MpicDetail',
          name: 'MpicDetail',
          component: MpicDetail
        },
        {
          path: '/MaboutUs/:selected',
          name: 'MaboutUs',
          component: MaboutUs
        }
      ]
    },
    {
      path: '/backstage',
      name: 'backstage',
      component: backstage,
      children: []
    },
    {
      path: '/htHome',
      name: 'htHome',
      component: htHome,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      children: [
        {
          path: '/ht_scheme',
          name: 'scheme',
          meta: {
            requireAuth: true
          },
          component: scheme
        },
        {
          path: '/ht_info',
          name: 'info',
          meta: {
            requireAuth: true
          },
          component: info
        },
        {
          path: '/ht_serverInfo',
          name: 'serverInfo',
          meta: {
            requireAuth: true
          },
          component: serverInfo
        },
        {
          path: '/ht_customCase',
          name: 'customCase',
          meta: {
            requireAuth: true
          },
          component: customCase
        },
        {
          path: '/ht_apply',
          name: 'ht_apply',
          meta: {
            requireAuth: true
          },
          component: ht_apply
        },
        {
          path: '/ht_pic',
          name: 'pic',
          meta: {
            requireAuth: true
          },
          component: pic
        },
        {
          path: '/ht_review',
          name: 'review',
          meta: {
            requireAuth: true
          },
          component: review
        },
        {
          path: '/ht_joinWe',
          name: 'joinWe',
          meta: {
            requireAuth: true
          },
          component: joinWe
        },
        {
          path: '/ht_experience',
          name: 'experience',
          meta: {
            requireAuth: true
          },
          component: experience
        },
        {
          path: '/ht_activity',
          name: 'ht_activity',
          meta: {
            requireAuth: true
          },
          component: ht_activity
        },
        {
          path: '/ht_addactivity',
          name: 'ht_addactivity',
          meta: {
            requireAuth: true
          },
          component: addactivity
        },
        {
          path: '/ht_updateActivity',
          name: 'ht_updateActivity',
          meta: {
            requireAuth: true
          },
          component: updateActivity
        },
        {
          path: '/ht_enterpriseInfo',
          name: 'ht_enterpriseInfo',
          meta: {
            requireAuth: true
          },
          component: enterpriseInfo
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) { // 判断是否需要登录权限
    if (sessionStorage.getItem('token')) { // 判断是否登录
      next()
    } else { // 没登录则跳转到登录界面
      next({
        path: '/backstage',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js